import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import React, { useState, useEffect, useRef } from 'react';
import { logOut } from "../../../../redux/apiRequest";
import { createAxios } from "../../../../createInstance";
import { logoutSuccess } from "../../../../redux/authSlice";
import styles from './Header.module.scss';
import classNames from 'classnames/bind';

import { GiBookCover } from "react-icons/gi";
import { GrLogout } from "react-icons/gr";

import logo from '../../../../assets/logo.png'
import defaultAvt from '../../../../assets/logo.png'
import { FiMenu, FiX } from 'react-icons/fi';
import { use } from "react";
const cx = classNames.bind(styles);
function Header({ user, onLogout, onSettings }) {
    const [menuOpen, setMenuOpen] = useState(false);
    const [navOpen, setNavOpen] = useState(false);
    const menuRef = useRef(null);

    // Đóng menu khi click ra ngoài
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (menuRef.current && !menuRef.current.contains(e.target)) {
                setMenuOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);
    return (
        <>
            <header className={cx("header")}>
                <div className={cx("header-left")}>
                    <img
                        src={logo}
                        alt="Logo"
                        className={cx("logo")}
                        onClick={() => window.location.href = '/'}
                    />

                </div>

                <div className={cx("header-right")} ref={menuRef}>
                    <button
                        className={cx("menuToggle")}
                        aria-label={navOpen ? "Đóng menu" : "Mở menu"}
                        onClick={() => setNavOpen((v) => !v)}
                    >
                        {navOpen ? <FiX /> : <FiMenu />}
                    </button>
                    <div>
                        <nav className={cx("nav", { navOpen })}>
                            {user?.admin && (
                                <>
                                    <button onClick={() => { setNavOpen(false); window.location.href = "/"; }}>Trang chủ</button>
                                    <button onClick={() => { setNavOpen(false); window.location.href = "/account"; }}>Tài khoản</button>
                                    <button onClick={() => { setNavOpen(false); window.location.href = "/baithi"; }}>Bài thi</button>
                                </>
                            )}
                        </nav>
                    </div>
                    <div
                        className={cx("user-info")}
                        onClick={() => setMenuOpen(!menuOpen)}
                    >
                        <span className={cx("username")}>{user?.fullname}</span>
                        <img
                            src={defaultAvt}
                            alt="Avatar"
                            className={cx("avatar")}
                        />

                    </div>

                    {menuOpen && (
                        <div className={cx("dropdown-menu")}>
                            <button onClick={onSettings}>Cài đặt</button>
                            <button onClick={onLogout}>Đăng xuất</button>
                        </div>
                    )}
                </div>
            </header>
        </>

    );
}
export default Header;
